<template>
  <symbol
    id="star-full"
    viewBox="0 0 28 26"
  >
    <path d="M13.493.959l-3.459 8.774-9.867.779 7.318 6.572-2.33 9.229 8.338-4.886 8.363 5.187-2.26-9.53 7.592-6.572-10.1-.78z" />
    <path
      stroke-miterlimit="20"
      d="M13.493.959v0l-3.459 8.774v0l-9.867.779v0l7.318 6.572v0l-2.33 9.229v0l8.338-4.886v0l8.363 5.187v0l-2.26-9.53v0l7.592-6.572v0l-10.1-.78v0z"
    />
  </symbol>
</template>
